import { ReactNode } from 'react'
import { TFunction } from 'i18next'

import BlizzardIcon from 'app/frontend/base/components/BlizzardIcon'
import {
  getAllSpecializations,
  getClass,
} from 'app/frontend/base/services/characterValues'
import { RaidPlanAssignmentEntity } from 'app/frontend/types/custom/RaidPlan'

const specializationById = getAllSpecializations()

const getClassColor = (className: string) =>
  `var(--color-class-${className.toLowerCase().replace(/\s+/g, '-')})`

export const getAssignmentEntityLabel = (
  t: TFunction,
  entity: RaidPlanAssignmentEntity,
): ReactNode => {
  if (entity.kind === 'member') {
    if (!entity.spec_id) return entity.label
    const specialization = specializationById[entity.spec_id.toString()]
    if (!specialization) return entity.label
    const className = getClass(specialization.class_id?.toString() ?? '')
    if (!className) return entity.label
    return (
      <span className='inline-flex items-center gap-1.5 min-w-0'>
        <BlizzardIcon
          iconName={specialization.icon}
          size='small'
          className='shrink-0'
        />
        <span
          className='truncate'
          style={{ color: getClassColor(className) }}
        >{`${specialization.name} ${className}`}</span>
      </span>
    )
  }
  if (entity.kind === 'everyone')
    return t('dashboard.team.plans.assignments.entities.everyone')
  if (entity.kind === 'collection') {
    return t(
      `dashboard.team.plans.assignments.entities.collection.${entity.collection}`,
    )
  }
  if (entity.kind === 'by_role') {
    return t(`dashboard.team.plans.assignments.entities.by-role.${entity.role}`)
  }
  if (entity.kind === 'group')
    return t('dashboard.team.plans.assignments.entities.group', {
      count: entity.group,
    })
  if (entity.kind === 'role') {
    const role =
      entity.role === 'heal'
        ? 'healer'
        : entity.role === 'tank'
        ? 'tank'
        : entity.role === 'ranged'
        ? 'ranged'
        : 'melee'
    return t(`dashboard.team.plans.assignments.entities.by-role.${role}`)
  }
  return t('shared.unknown')
}
